import { DataSource, Label, Layout, Panel, StarRating, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPayeeSummaryQuickInfo extends Layout {
    labelListSubtitle: Label;
    labelListTitle: Label;
    panelPayeeInfo: Panel;
    panelPayeeList: Panel;
    sourcePayeeSummary: DataSource;
    sourceSelectedPayee: DataSource;
    starratingC: StarRating;
    tablePayees: Table;
    textboxAddress: Textbox;
    textboxContactphone: Textbox;
    textboxDotNumber: Textbox;
    textboxEmail: Textbox;
    textboxFleetManager: Textbox;
    textboxIccNumber: Textbox;
    textboxId: Textbox;
    textboxMovementId: Textbox;
    textboxName: Textbox;
}
